import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    isComplete: false,
    error: null,
    companyId: null
};

const accountSetupSlice = createSlice({
    name: 'accountSetup',
    initialState,
    reducers: {
        setupAccountRequest: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        setupAccountSuccess: (state, action) => {
            state.isLoading = false;
            state.isComplete = true;
            state.companyId = action.payload.companyId;
            state.error = null;
        },
        setupAccountFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        resetAccountSetup: (state) => {
            state.isLoading = false;
            state.isComplete = false;
            state.error = null;
            state.companyId = null;
        }
    }
});

export const { setupAccountRequest, setupAccountSuccess, setupAccountFailure, resetAccountSetup } = accountSetupSlice.actions;
export default accountSetupSlice.reducer;
